import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/common.js';

import mobile from "is-mobile";

Vue.component("pager", Pager);
Vue.component('common', Common);

// HTML 엔티티를 디코딩해 순수 문자로 변환
function decodeEntities(str = '') {
  try {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  } catch (e) {
    return str || '';
  }
}

// 필요 시 마크업까지 제거하려면 아래 함수를 사용하고, decodeEntities 대신 toPlainText를 적용하세요.
// function toPlainText(str = '') {
//   const decoded = decodeEntities(str);
//   return decoded.replace(/<[^>]*>/g, '');
// }

new Vue({
  el: '#schoolPrivateList',
  data: function() {
    return {
      mainName:'공모전/대외활동',
      schoolPrivateList: {
        list: [],
        totalCount: 0,
        showMore: true,
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnOnPostFaq(n);
          }
        }
      }
    }
  },
  mounted: function() {
    let vm = this;
    this.fetchSchoolPrivate();
  },
  methods:{
    fetchSchoolPrivate:function(pageNumber = 1){
      const vm = this;
      vm.schoolPrivateList.pager.pageNo = pageNumber;

      const param = {
        pageNo: vm.schoolPrivateList.pager.pageNo,
        pageSize: vm.schoolPrivateList.pager.rowSize
      };

      Axios.post("/api/afterschool/privateSchool/list", param).then(function(response) {
        vm.schoolPrivateList.totalCount = response.data.schoolPrivateDTO.paramListCnt;
        vm.schoolPrivateList.pager.totalSize = response.data.schoolPrivateDTO.paramListCnt;
        vm.schoolPrivateList.pageNum = (vm.schoolPrivateList.pager.pageNo * vm.schoolPrivateList.pager.rowSize) - vm.schoolPrivateList.pager.rowSize;

        const list = (response.data.schoolPrivateDTO || []).map(item => ({
          ...item,
          // 엔티티만 디코딩하여 순수 문자로 출력되도록 정규화
          CMM_TITL: decodeEntities(item.CMM_TITL)
          // 필요 시 마크업 제거까지 원하면 다음 라인으로 교체
          // CMM_TITL: toPlainText(item.CMM_TITL)
        }));

        vm.schoolPrivateList.list = vm.schoolPrivateList.list.concat(list);
        vm.schoolPrivateList.showMore = true;
      }).catch(function(ex) {
        console.log(ex);
      });
    }
  }
});
